import './index.css';
import WeatherApp from './Component/WeatherApp';

function App() {
  return (
    <div className="app">
      <WeatherApp />
    </div>
  );
}

export default App;
